import React from "react";
import { Chart } from "react-google-charts";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";

const ColumnChart = (props) => {
  const { data, chartColors, showPercentageSign, heading } = props;

  // const navigate = useNavigate();

  const isAdmin = useSelector((state) => state?.auth?.isAdmin);
  const route = isAdmin ? "/admin" : "";
  const dashboardFilters = useSelector((state) => state?.auth?.dashboardHomeFilters);

  // Function to check if all values in data (excluding header) are zero
  const allZeroValues = data?.slice(1).every((row) => row[1] === 0);

  const vAxisTicks = [
    { v: 0, f: "0%" },
    { v: 20, f: "20%" },
    { v: 40, f: "40%" },
    { v: 60, f: "60%" },
    { v: 80, f: "80%" },
    // {v: 100, f: '100%'},
  ];

  // Conditionally format the vAxis labels to include a '%' sign
  const vAxisOptions = showPercentageSign
    ? {
      format: "short", // Keeps the axis numbers short and readable
      textStyle: {
        // Additional styling can go here
      },
      ticks: vAxisTicks,
    }
    : {};

  const options = {
    chartArea: { width: "90%", left: "10%" },
    legend: {
      position: "top",
      labeledValueText: "both",
      textStyle: { fontSize: 13 },
      alignment: "center",
    },
    hAxis: {
      // title: 'Total Population',
      minValue: 0,
      minorGridlines: {
        color: "transparent", // Optional: Hides minor vertical gridlines if present
      },
    },
    vAxis: {
      // title: 'Day',
      ...vAxisOptions, // Spread the conditional vAxis options
      minorGridlines: {
        color: "transparent", // Optional: Hides minor vertical gridlines if present
      },
      // Ensure we show zero values on the axis
      viewWindow: {
        min: 0
      },
      // Use logarithmic scale to better show both small and large values
      scaleType: 'mirrorLog'
    },
    colors: chartColors ? chartColors : ["#fbd898", "#76af74"],
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 12,
        auraColor: "none",
        color: "#555",
        fontWeight: "700",
      },
    },
    // Make sure bars are visible even with small values
    bar: { 
      groupWidth: '75%',
      // Ensure minimum bar height for visibility
      minHeight: 5 
    },
    isStacked: false
  };
  const chartEvents = [
    {
      eventName: "select",
      callback: ({ chartWrapper }) => {
        const chart = chartWrapper.getChart();
        const selection = chart.getSelection();
        if (heading === "Vas booked" || heading === "Vas retailed") {
          return;
        } else {
          if (selection.length === 0) return;
          let item = selection[0];

          // Adjust the column index if it's outside the expected data range
          if (item.column > data[0].length - 1) {
            item.column -= 1; // Adjust to target the correct data column
          }
          if (item.row !== null && item.column !== null) {
            let selectedRowData;
            let selectedMetric;
            selectedRowData = data[item.row + 1];

            // Ensure that you're accessing a string before calling .split()
            if (typeof data[0][item.column] === "string") {
              selectedMetric = data[0][item.column]
                .split(" ")
                .join("_")
                .toLowerCase();
              const selectedValue = selectedRowData[item.column];

              // Extract the duration from the interval
              let duration;
              const intervalText = selectedRowData[0];

              // Handle all specific duration cases
              if (intervalText.includes("0-10")) {
                duration = "0-10";
              } else if (intervalText.includes("11-20")) {
                duration = "11-20";
              } else if (intervalText.includes("21-30")) {
                duration = "21-30";
              } else if (intervalText.includes("31-40")) {
                duration = "31-40";
              } else if (intervalText.includes("41-50")) {
                duration = "41-50";
              } else if (intervalText.includes("> 60 Days & < 120 Days")) {
                duration = "60-120";
              } else if (intervalText.includes(">")) {
                // Extract the number after ">"
                const match = intervalText.match(/>\s*(\d+)/);
                duration = match ? match[1] : "0";
              } else {
                // Extract the first number in the interval
                const match = intervalText.match(/(\d+)/);
                duration = match ? match[1] : "0";
              }

              // Format dates properly for URL
              const formatDateForUrl = (dateStr) => {
                if (!dateStr) return "";
                // Check if it's already a string date format
                if (typeof dateStr === 'string' && dateStr.includes('-')) {
                  return dateStr;
                }
                // Try to convert to YYYY-MM-DD format
                try {
                  const date = new Date(dateStr);
                  if (isNaN(date.getTime())) return "";
                  return date.toISOString().split('T')[0]; // YYYY-MM-DD format
                } catch (e) {
                  return "";
                }
              };

              const startDateFormatted = formatDateForUrl(dashboardFilters?.startDate);
              const endDateFormatted = formatDateForUrl(dashboardFilters?.endDate);

              // Use direct window location change instead of navigate to prevent infinite loops
              const url = `${route}/leads?metrics=${selectedMetric}&graph_duration=${duration}&graph_value=${selectedValue}&date_range=>&start_date=${startDateFormatted}&end_date=${endDateFormatted}&dashboard_redirect=true&key=hot_lead`;
              
              // Use window.location.href for a full page reload to break any React state cycles
              window.location.href = url;
            } else {
              // Handle cases where data[0][item.column] is not a string
              return;
            }
          } else {
            return;
          }
        }
      },
    },
  ];

  return (
    <div>
      {allZeroValues ? (
        <div className="align-items-center">
          <p>No Data to display</p>
        </div>
      ) : (
        <Chart
          chartType="ColumnChart"
          width="100%"
          height="400px"
          loader={<div>Loading Chart</div>}
          data={data}
          chartEvents={chartEvents}
          options={options}
          className="column-chart-cursor-pointer"
        />
      )}
    </div>
  );
};
export default ColumnChart;
